import { motion } from 'framer-motion';
import { pressItems, pullQuote } from '../../../mocks/portfolio';

const Press = () => {
  return (
    <section id="press" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-serif text-5xl md:text-6xl font-light text-center text-gray-900 mb-16"
        >
          Press &amp; Recognition
        </motion.h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {pressItems.map((item, index) => (
            <motion.article
              key={item.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 cursor-pointer"
            >
              <div className="mb-4 h-12 flex items-center">
                <img
                  src={item.logo}
                  alt={item.publication}
                  className="h-8 object-contain grayscale opacity-70"
                />
              </div>
              <h3 className="font-bold text-xl text-gray-900 mb-3 leading-tight">
                {item.headline}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                {item.excerpt}
              </p>
              <div className="text-xs uppercase tracking-wider text-gray-500">
                {item.publication} • {item.date}
              </div>
            </motion.article>
          ))}
        </div>

        {/* Pull Quote */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-16 bg-gradient-to-br from-burgundy to-red-900 rounded-3xl p-12 text-center"
        >
          <blockquote className="font-serif text-3xl md:text-4xl italic text-white mb-6 leading-relaxed">
            "{pullQuote.text}"
          </blockquote>
          <cite className="text-sm uppercase tracking-widest text-white/80 not-italic">
            {pullQuote.critic}, {pullQuote.publication}
          </cite>
        </motion.div>
      </div>
    </section>
  );
};

export default Press;